import { render, staticRenderFns } from "./productList.vue?vue&type=template&id=24051f94&scoped=true"
import script from "./productList?vue&type=script&lang=js&external"
export * from "./productList?vue&type=script&lang=js&external"
import style0 from "./productList.vue?vue&type=style&index=0&id=24051f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24051f94",
  null
  
)

export default component.exports